module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"header":"Aktualności"},"en":{"header":"News"}}')
  delete Component.options._Ctor
}
